export const POPULAR_CAR_MAKERS = [
  "Maruti",
  "Hyundai",
  "Mahindra",
  "Tata",
  "Honda",
  "Kia",
  "Renault",
  "Nissan",
  "Toyota",
] as const;

export const CAR_MAKER_FILTER_LABEL = "Car Maker";

export const sortCarMakersWithPopularsFirst = <
  T extends { label: string; value: string },
>(
  items: T[],
  popularNames: readonly string[] = POPULAR_CAR_MAKERS,
): T[] => {
  const popularIndexByName = new Map(
    popularNames.map((name, index) => [name.toLowerCase(), index]),
  );

  const populars: T[] = [];
  const others: T[] = [];

  items.forEach((item) => {
    const key = item.label.trim().toLowerCase();
    if (popularIndexByName.has(key)) {
      populars.push(item);
    } else {
      others.push(item);
    }
  });

  populars.sort((a, b) => {
    const aIndex =
      popularIndexByName.get(a.label.trim().toLowerCase()) ??
      Number.MAX_SAFE_INTEGER;
    const bIndex =
      popularIndexByName.get(b.label.trim().toLowerCase()) ??
      Number.MAX_SAFE_INTEGER;
    return aIndex - bIndex;
  });

  others.sort((a, b) =>
    a.label.localeCompare(b.label, undefined, { sensitivity: "base" }),
  );

  return [...populars, ...others];
};

export const formatCarMakerFilterDisplay = (
  selectedLabels: string[],
): string => {
  if (selectedLabels.length === 0) {
    return "";
  }
  if (selectedLabels.length === 1) {
    return selectedLabels[0];
  }
  return `${selectedLabels.length} selected`;
};

export const encodeCarMakerFilter = (selectedNames: string[]): string => {
  if (selectedNames.length === 0) {
    return "";
  }
  return selectedNames
    .map((name) => `&carMaker=${encodeURIComponent(name)}`)
    .join("");
};

export const decodeCarMakerFilter = (encoded: string | undefined): string[] => {
  if (!encoded) {
    return [];
  }
  return encoded
    .split("&carMaker=")
    .slice(1)
    .filter(Boolean)
    .map((name) => {
      try {
        return decodeURIComponent(name);
      } catch {
        return name;
      }
    });
};

